import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';
import { formatDateTime } from '@/format';
import { useCompany } from '@/stores/company';

/**
 * Which build of the app and the server this is. The first thing to ask when
 * someone reports a problem, so it is one click away (F1, or Settings › About).
 */
export function AboutFacts() {
  const company = useCompany((s) => s.company);
  const about = useQuery({
    queryKey: ['about'],
    queryFn: () => api.get('/api/v1/about'),
    staleTime: 60_000,
  });

  const server = about.data;

  return (
    <dl className="settings__facts aboutfacts">
      <div>
        <dt>Company</dt>
        <dd>{company.nameEn}</dd>
      </div>
      <div>
        <dt>App version</dt>
        <dd>
          {__APP_VERSION__}
          {__GIT_SHA__ && <span className="muted"> ({__GIT_SHA__.slice(0, 7)})</span>}
        </dd>
      </div>
      <div>
        <dt>App built</dt>
        <dd>{formatDateTime(__BUILD_TIME__)}</dd>
      </div>
      <div>
        <dt>Server version</dt>
        <dd>
          {about.isError
            ? 'Cannot reach the server'
            : server
              ? `${server.apiVersion}${server.commit ? ` (${server.commit.slice(0, 7)})` : ''}`
              : '…'}
        </dd>
      </div>
      <div>
        <dt>Server running since</dt>
        <dd>{server ? formatDateTime(server.startedAt) : '—'}</dd>
      </div>
      <div>
        <dt>Database</dt>
        <dd>{server ? (server.database === 'ok' ? 'Working' : 'Not reachable') : '—'}</dd>
      </div>
      {server && server.environment !== 'production' && (
        <div>
          <dt>Environment</dt>
          <dd>{server.environment}</dd>
        </div>
      )}
    </dl>
  );
}
